<template>
  <NewBsBox
    :bs="tagVbs"
    class="tag-wrapper"
    :context="this.$props"
  >
    <slot name="left">
      <BeerIcon
        v-if="iconBefore || leftIcon"
        :icon="iconBefore || leftIcon"
        class="tag-left"
        :color="null"
        :size="12"
        @click="handleLeftIcon"
      />
    </slot>
    <span class="tag-text"><slot /></span>
    <slot name="right">
      <BeerIcon
        v-if="iconAfter || icon"
        :icon="iconAfter || icon"
        class="tag-right"
        :bs="{
          '&:hover': {
            cursor: 'pointer'
          },
        }"
        :color="null"
        :size="12"
        role="button"
        @click="handelRightIcon"
      />
    </slot>
  </NewBsBox>
</template>
<script lang="ts">
  import { PropType, defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import initStyle from './style.js'

  initStyle()

  /**
   * 基础的 Tag 标签
   */
  export default defineComponent({
    name: 'BeerTag',
    components: {
      NewBsBox,
      BeerIcon,
    },
    props: {
      /**
       * 意图颜色, 当 variant 非 grey 的时候起作用
       * 设置标签颜色，只有当variant 的值不是 'grey'时生效
       *
       * @type {mute|primary|info|warn|danger}
       */
      modifier: {
        type: String as PropType<string>,
        default: 'mute',
      },
      /**
       * 设置标签的样式类型
       * @type {grey|fill|outline}
       */
      variant: {
        type: String as PropType<string>,
        default: 'grey', // empty default outline
      },
      /**
       * 容器样式
       *
       * @ignore
       * @see style
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 文本样式
       *
       * @ignore
       * @see style
       */
      textBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 使用 iconAfter
       * @deprecated 4.1.0
       */
      icon: {
        type: String as PropType<string>,
      },
      /**
       * 使用 iconBefore
       * @deprecated 4.1.0
       */
      leftIcon: {
        type: String as PropType<string>,
        required: false,
      },
      /**
       * 左边的图标
       * @version 4.1.0
       */
      iconBefore: {
        type: String as PropType<string>,
        required: false,
      },
      /**
       * 右边的图标
       * @version 4.1.0
       */
      iconAfter: {
        type: String as PropType<string>,
      },
      /**
       * @deprecated
       *
       * 推荐使用 `@click:icon`
       * 右边图标点击事件回调方法
       */
      onClickIcon: {
        type: Function,
        required: false,
      },
    },
    emits: ['click:icon', 'click:left'],
    computed: {
      tagVbs() : BeerStyleObj {
        return {
          'cmp.tag': 'wrapper',
          'cmp.tag.wrapperVariant': this.variant,
          '.tag-text': {
            ...this.textVbs,
          },
          cursor: this.$attrs.onClick ? 'pointer' : undefined,
          ...this.bs,
        }
      },
      textVbs(): BeerStyleObj {
        const vnodes = this.$slots.default
          ? this.$slots.default() || []
          : []

        // slot有 html tag 或者 component 的时候
        const notPlainText = vnodes.some(vnode => typeof vnode.type !== 'symbol')
        const styl = notPlainText ? {} : {
          'cmp.tag': 'text',
          mr: (this.icon || this.iconAfter) ? 12 : undefined,
          ml: (this.leftIcon || this.iconBefore) ? 8 : undefined,
        }

        return {
          ...styl,
          ...this.textBs,
        }
      },
    },
    methods: {
      handelRightIcon(e: Event) {
        this.onClickIcon?.(e)

        /**
         * 点击右边的 icon
         */
        this.$emit('click:icon', e)
      },
      handleLeftIcon(e: Event) {
        /**
         * 点击左边的 icon
         */
        this.$emit('click:left', e)
      },
    },
  })
</script>
